<mm-radio-control [parentForm]="parentForm" [radioModel]="useTemplatesModel"></mm-radio-control>
<ng-container *ngIf="showTemplateOptions">
  <div data-testid="template-options">
    <mm-standing-authorization-card-container
      *ngIf="enableUseSloaContainer; else legacyTemplateControl"
      [label]="'Select a template'"
      [authorizationCount]="templateCards.length"
      [cards]="templateCards"
      [isWireTemplateView]="true"
      (cardSelected)="onTemplateCardSelected($event)">
    </mm-standing-authorization-card-container>
    <ng-template #legacyTemplateControl>
      <mm-card-component [parentForm]="parentForm" [cardModel]="cardModel">
      </mm-card-component>
    </ng-template>
  </div>
</ng-container>